/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setGMenuHoverAction.js
 * 
 * グローバルメニュー用スクリプト
 * 
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/**
 * メニューホバーアクション
*/
function setGMenuHoverAction() {
    var menuItem = document.querySelectorAll(".site-header__grobal-nav .menu-item > a");
    var delay = 0;

    for (let i = 0; i < menuItem.length; i++) {
        menuItem[i].addEventListener("mouseenter", (e) => {
            let currentMenuItem = e.currentTarget;
            let menuItemEn = currentMenuItem.querySelectorAll(".en > span");
            let menuItemJp = currentMenuItem.querySelectorAll(".jp > span");

            for (let i = 0; i < menuItemEn.length; i++) {
                delay += 0.01;
                menuItemEn[i].style.setProperty("transition-delay", `${delay}s`);
            }

            for (let i = 0; i < menuItemJp.length; i++) {
                delay += 0.01;
                menuItemJp[i].style.setProperty("transition-delay", `${delay}s`);
            }

            delay = 0;
        });

        menuItem[i].addEventListener("mouseleave", (e) => {
            delay = 0;
            let currentMenuItem = e.currentTarget;
            let menuItemEn = currentMenuItem.querySelectorAll(".en > span");
            let menuItemJp = currentMenuItem.querySelectorAll(".jp > span");

            for (let i = 0; i < menuItemEn.length; i++) {
                menuItemEn[i].style.setProperty("transition-delay", `${delay}s`);
            }

            for (let i = 0; i < menuItemJp.length; i++) {
                menuItemJp[i].style.setProperty("transition-delay", `${delay}s`);
            }
        })
    }
}

export { setGMenuHoverAction }